let medicament = {
    init() {
        $('.medicament-abecedaire .on:nth-of-type(1)').addClass('active');
        var letter = $('.medicament-abecedaire .on.active').attr('id');

        $('.medicament-liste .letter-content').hide();
        $('.medicament-liste .'+letter).show();

        $('.medicament-abecedaire .on').click(function(){
            $('.medicament-abecedaire .on').removeClass('active');
            $(this).addClass('active');

            var letter = $(this).attr('id');
            $('.medicament-liste .letter-content').fadeOut(300);
            $('.medicament-liste .'+letter).delay(300).fadeIn(300);

        })

    }
}

export default medicament;
